import { Component } from '@angular/core';

import { ConfirmDialogVariant, DialogComponentI, DialogRef } from '@recruitee/user-interface';

type DialogData = {};

@Component({
  selector: 'rt-block-password-change-dialog',
  templateUrl: './block-password-change-dialog.component.html',
})
export class BlockPasswordChangeDialogComponent implements DialogComponentI<DialogData, boolean> {
  public readonly ConfirmDialogVariant = ConfirmDialogVariant;

  constructor(private dialog: DialogRef) {}

  public close(): void {
    this.dialog.close();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: DialogData, triggerUpdate: boolean): void {}
}
